// extracted by mini-css-extract-plugin
export default {"container":"style_container__e7KeE","legends":"style_legends__jPTE2","scrollable":"style_scrollable__3QfdA","button":"style_button__SRBBN"};